import axios from '@/allotment/axios'

export default {
  get: () => axios.get('/agreement/get', {}), //获取协议数据
  save: data => axios.post('/agreement/save', data) //保存协议数据
}